const NetworkType = {
    1: 'TV',
    2: 'Radio',
};

export default NetworkType